import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Laura', 'Sofía', 'Valentina', 'Camila', 'Martina', 'Lucía', 'Florencia', 'Daniela', 'Julieta', 'Agustina', 'Micaela'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'San Juan', 'Resistencia'];
const PACKS = ['Megapack Élite', 'Pack Esencial'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    pack: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomPack = PACKS[Math.floor(Math.random() * PACKS.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 mins ago
      setPurchaseData({
        name: randomName,
        city: randomCity,
        pack: randomPack,
        time: `Hace ${randomTime} min`
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 3000);
    // Then show every 30 seconds
    const interval = setInterval(() => {
      showPopup();
    }, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-155">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-xl shadow-2xl border border-purple-100 p-4 flex items-start gap-3" data-id="element-156">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-157">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-158" />
          </div>
          <div data-id="element-159">
            <p className="text-sm text-gray-800" data-id="element-160">
              <span className="font-bold" data-id="element-161">{purchaseData.name}</span> de{' '}
              {purchaseData.city}
            </p>
            <p className="text-sm text-gray-600" data-id="element-162">
              Acaba de comprar el{' '}
              <span className="font-semibold text-purple-700" data-id="element-163">
                {purchaseData.pack}
              </span>
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-164">{purchaseData.time}</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}